import { createFileRoute } from '@tanstack/react-router'

import {
  curriculumsManagementFiltersSchema,
  CurriculumsManagementListView
} from '@/modules/curriculumsManagement'

export const Route = createFileRoute('/_auth/curricula/')({
  component: CurriculumsManagementListView,
  validateSearch: curriculumsManagementFiltersSchema
})
